import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de_DE from "./de_DE.json";
import en_US from "./en_US.json";
import es_ES from "./es_ES.json";
import fr_FR from "./fr_FR.json";
import ja_JP from "./ja_JP.json";
import pt_BR from "./pt_BR.json";
import ru_RU from "./ru_RU.json";
import zh_CN from "./zh_CN.json";
import zh_TW from "./zh_TW.json";

const resources = {
  de: {
    translation: de_DE,
  },
  en: {
    translation: en_US,
  },
  es: {
    translation: es_ES,
  },
  fr: {
    translation: fr_FR,
  },
  jp: {
    translation: ja_JP,
  },
  pt: {
    translation: pt_BR,
  },
  ru: {
    translation: ru_RU,
  },
  cn: {
    translation: zh_CN,
  },
  tw: {
    translation: zh_TW,
  },
};

i18n
  .use(initReactI18next) 
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

  export default i18n;